import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  displayTimeField,
} from "../../../utils/helpers";

const ProductCostCell = ({
  rowData,
  positionFromRight = "50",
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("COST") + " " + t("DETAIL") + ":"}>
      <p>
        {rowData.product_cost && (
          <p>
            {t("COST")}: {displayField(rowData.product_cost)} (
            {displayField(rowData.product_cost_percent)}% {t("OF")}{" "}
            {displayField(rowData.tentative_price)})
          </p>
        )}
        <p>
          {t("COST")} {t("BREAKUP")}: <br />{" "}
          {displayField(rowData.product_cost_detail)}
        </p>
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper speaker={speaker} enterable={true} preventOverflow={true}>
        <a>{displayField(rowData.product_cost)}</a>
      </Whisper>
    </Cell>
  );
};

export default ProductCostCell;
